<div class="circle-container" #circleContainer>
  <svg
    #svg
    xmlns="http://www.w3.org/2000/svg"
    class="svg-progress-bar"
    viewBox="-1 -1 2 2"
    style="transform: rotate(-90deg)"
  >
    <circle
      cx="0"
      cy="0"
      fill="none"
      r="0.9"
      [style.stroke]="currentBgColor"
      stroke-width="0.15"
    ></circle>
  </svg>
</div>
